import { SizeProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IIcon } from "./CircleIcon.interfaces"
import { StyledBox } from "./CircleIcon.styled"
import { useTheme } from "@mui/material"

const getFontSize = (size: string | undefined) => {
  switch (size) {
    case "xl":
      return "2x"
    case "lg":
      return "xl"
    case "md":
      return "lg"
    case "sm":
      return "md"
    case "xs":
      return "sm"
    default:
      return "md"
  }
}

export const CircleIcon = (props: IIcon) => {
  const { icon, size, color } = props
  const theme = useTheme()

  return (
    <StyledBox {...props}>
      <FontAwesomeIcon size={getFontSize(size) as SizeProp} icon={icon} color={color ? color : (theme.palette as any).primary[800]} />
    </StyledBox>
  )
}
